<template>
  <Page class="detailView">
    <Material :dataType="dataType" :type="type" :productId="productId" :materialTypeId="materialTypeId" :productType="1"></Material>
  </Page>
</template>

<script>
import Page from '@/components/Page'
import Material from '../modules/Material.vue'
export default {
  components: {
    Page,
    Material,
  },
  data() {
    return {
      type: true,
      dataType: '',
      productId: '',
      materialTypeId: '',
    }
  },
  created() {
    const { dataType, materialTypeId, productId } = JSON.parse(this.$route.query.data)
    this.dataType = dataType
    this.materialTypeId = materialTypeId
    this.productId = productId
  },
}
</script>

<style lang="less"></style>
